import { UTM_PARAMS } from '@dupe/common/constants'
import { useRouter } from 'next/compat/router'
import { useMemo } from 'react'

/**
 * The UTM params on the current URL. `next/compat/router` is null under the
 * App Router (e.g. /reports, whose header shares components with pages/), so
 * there it reads the browser's URL instead of throwing "NextRouter was not
 * mounted".
 */
const useCaptureUTMParams = () => {
  const router = useRouter()
  const queryParams = router?.query
  const search = typeof window === 'undefined' ? '' : window.location.search

  const utmParams = useMemo(() => {
    const read = (param: string): string | undefined => {
      if (queryParams) {
        const value = queryParams[param]
        return Array.isArray(value) ? value[0] : value
      }
      return new URLSearchParams(search).get(param) ?? undefined
    }
    return UTM_PARAMS.reduce<Record<string, string>>((acc, param) => {
      const value = read(param)
      if (value) acc[param] = value
      return acc
    }, {})
  }, [queryParams, search])

  return utmParams
}

export default useCaptureUTMParams
